import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  Output
} from '@angular/core';


export class ClickOutDirective {

   exclude: string;

   readonly clickOut: EventEmitter<any> = new EventEmitter();

  
  onClick(event: MouseEvent, target: HTMLElement): void {
    if (!target) {
      return;
    }

    const clickedInside = this.element.nativeElement.contains(target);

    if (this.exclude) {
      this.isExcluded = this.excludeCheck(target);
    }

    if (!clickedInside && !this.isExcluded) {
      this.clickOut.emit(event);
    }
  }

  private isExcluded: boolean = false;
  constructor(private element: ElementRef) {
  }

  excludeCheck(target: HTMLElement) {
    const excludeElements = Array.from(document.querySelectorAll(this.exclude)) as Array<HTMLElement>;
    for (let element of excludeElements) {
      if (element.contains(target)) {
        return true;
      }
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[clickOut]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'exclude': [{ type: Input, args: ['exclude', ] },],
'clickOut': [{ type: Output, args: ['clickOut', ] },],
'onClick': [{ type: HostListener, args: ['document:click', ['$event', '$event.target'], ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
